/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import ngAnimate from 'angular-animate';

export default angular.module('tektelic.components.noAnimate', [ngAnimate])
    .directive('tkNoAnimate', NoAnimate)
    .name;

/*@ngInject*/
function NoAnimate($animate) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            $animate.enabled(element, false);
            scope.$watch(function () {
                $animate.enabled(element, false)
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/components/no-animate.directive.js